import { render, staticRenderFns } from "./MapPassageListCard.vue?vue&type=template&id=331a0d1b&scoped=true"
import script from "./MapPassageListCard.vue?vue&type=script&lang=js"
export * from "./MapPassageListCard.vue?vue&type=script&lang=js"
import style0 from "./MapPassageListCard.vue?vue&type=style&index=0&id=331a0d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a0d1b",
  null
  
)

export default component.exports